import { NavLink } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { NAVIGATION } from '../data/NavigationData';
import UtilityBar from './UtilityBar';
import TrustBadge from './TrustBadge';
import ukrainian from '../images/ukrainian.svg';
import './Navigation.css';

// Desktop header (large screens only, see Navigation.css).
// Mobile uses SideBar.js. Menu items come from data/NavigationData.js.
function Menu() {
    return (
        <div className="siteHeader">
            <UtilityBar showButtons />
            <header className="mainBar">
                <div className="mainBarInner">
                    <NavLink to="/" className="mainBarLogo">
                        <img src={ukrainian} width="56" height="56" alt="Ukrainian Logo" />
                    </NavLink>
                    <TrustBadge />
                    <nav>
                        <ul className="mainNav">
                            {NAVIGATION.map((item) => (
                                <li key={item.label} className="mainNavItem">
                                    {item.children ? (
                                        // Dropdown: opens on hover or keyboard focus (pure CSS)
                                        <>
                                            <button type="button" className="mainNavLink hasDropdown">
                                                <Trans ns="navigation" i18nKey={item.label} />
                                            </button>
                                            <ul className="dropdownCard">
                                                {item.children.map((child) => (
                                                    <li key={child.label}>
                                                        <NavLink to={child.to}>
                                                            <Trans ns="navigation" i18nKey={child.label} />
                                                        </NavLink>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    ) : (
                                        // `end` stops "Home" being highlighted on every page
                                        <NavLink to={item.to} end={item.to === '/'} className="mainNavLink">
                                            <Trans ns="navigation" i18nKey={item.label} />
                                        </NavLink>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            </header>
        </div>
    );
}

export default Menu;
